// Handles the link from the change-email confirmation message
// (#!/confirm_email/:token, see RegistrationsController#update_email).
angular.module('registration')
.controller('ConfirmEmailController', ['$state', '$stateParams', '$q', '$uibModal', 'ModalHandler', 'Registration', 'Login', 'Auth', 'redirect', 'AccountSetupActions', 'EmailSuppressionWarning', 'TrialExpiryWarning', 'Notification',
    function ($state, $stateParams, $q, $uibModal, ModalHandler, Registration, Login, Auth, redirect, AccountSetupActions, EmailSuppressionWarning, TrialExpiryWarning, Notification) {

        // A changed email signs this browser out, the way logout does. The
        // result dialog asks for a login with the new address, and a login
        // kept from before would carry the old address in auth_context and
        // bounce sign-in straight back to /history.
        function signOut() {
            // DELETE /sign_out needs the auth cookie; without a login there is
            // nothing to end on the server. Its failure (a dead token 401s) is
            // as good as success here, so both continue to the dialog.
            var serverSignOut = Auth.get() ? Login.logout().$promise.catch(angular.noop) : $q.resolve();
            return serverSignOut.then(function () {
                Auth.remove();
                Auth.current_user = null;
                AccountSetupActions.reset();
                EmailSuppressionWarning.reset();
                TrialExpiryWarning.reset();
                Notification.dismiss();
                redirect.path = '/history';
            });
        }

        function showResult() {
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/change_email_result.html',
                controller: 'EmailChangeResultController'
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.finally(function () {
                $state.go('signIn');
            });
        }

        Registration.confirmEmail({confirmation_token: $stateParams.token}).$promise
            .then(function () {
                // Waiting for the sign-out keeps its token reset from landing
                // after a quick new login, which reuses the same token.
                return signOut().then(showResult);
            }, function (response) {
                // The server answers every failure (unknown, expired or
                // already used token) with 422; anything else would
                // otherwise leave a blank page. user.exists: another account
                // took the address after the link was mailed (DCL-666).
                var errors = response && response.data && response.data.errors;
                var messages = (errors && errors.message) || [];
                var key = messages.indexOf('user.exists') !== -1 ? 'email.change.taken' : 'confirmation_token.invalid';
                $state.go('error_page', {error_key: key});
            });
    }]);
